let title = ' | Gestor - Comercial Ivaiporã'

const rupturas = {
    path: '/ruptura-abastecimento',
    props: true,
    component: () => import('@/Components/Rupturas/RupturasContainer.vue'),
    children: [
        {
            path: '',
            name: 'RupturasAbastecimentos',
            component: () => import('@/Components/Rupturas/RupturasDashboard.vue'),
            meta: {
                title: 'Rupturas' + title,
                permission: 'rupturas_menu',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Rupturas',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/liberacao',
                    }
                ]
            }
        }
    ]
}

export default rupturas